import Styles from './MediaFilePreview.module.scss'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { useState } from 'react'
import cx from 'classnames'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { SelectedImage } from 'types'

interface Props {
  mediaFile: SelectedImage
  isDisabled?: boolean
  isSelected: boolean
  alt?: string
  ariaLabel?: string
  showVideoPreview?: boolean
}

export const MediaFilePreview = ({
  mediaFile,
  isDisabled,
  isSelected,
  alt,
  ariaLabel,
  showVideoPreview = true,
}: Props) => {
  const imagePickerContext = useImagePickerContext()
  const [videoLoaded, setVideoLoaded] = useState(false)
  const { toggleSelectedImage } = imagePickerContext

  return (
    <div
      className={cx(Styles.image, { [Styles.isSelected]: isSelected, [Styles.isDisabled]: isDisabled })}
      aria-label={ariaLabel}
      onClick={() => toggleSelectedImage(mediaFile)}
    >
      {mediaFile.duration ? (
        <>
          <img
            src={mediaFile.thumbnail_url}
            alt={alt}
            className={cx({ [Styles.hidden]: !!videoLoaded && !showVideoPreview })}
          />
          {showVideoPreview && (
            <video
              src={mediaFile.preview_variant_url || mediaFile.source_url}
              autoPlay
              muted
              loop
              onLoadedData={() => setVideoLoaded(true)}
              className={cx({ [Styles.hidden]: !videoLoaded })}
            />
          )}
          <VideoDuration duration={mediaFile.duration} />
        </>
      ) : (
        <img src={mediaFile.url} alt={alt} />
      )}
      {isSelected && (
        <>
          <div className={Styles.checkbox}>
            <Checkbox size="lg" isSelected aria-label="Selected image" />
          </div>
        </>
      )}
    </div>
  )
}
